import { createActions, createReducer } from 'reduxsauce'
import { transformTickets } from './transform/tickets'

const { Types, Creators } = createActions({
    //NOTE: Do not pass the keyword "type" as an argument, as it will override the action type name.
    getTickets: [],
    getTicketsSuccess: ['allTickets'],
    getTicketsFailure: [],

    closeTicket: ['ticketId', 'callback'],
    closeTicketSuccess: [],
    closeTicketFailure: [],

    getThread: ['ticketId'],
    getThreadSuccess: ['ticketId', 'thread'],
    getThreadFailure: ['getThreadError'],
})

export const TicketsTypes = Types

const INITIAL_STATE = {
    tickets: [],
    allTickets: [],
    loadingTickets: false,
    loadingCloseTicket: false,
    loadingThreadId: null,
    threads: {},
    getThreadError: null,
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_TICKETS]: state => ({
        ...state,
        loadingTickets: true,
    }),
    [Types.GET_TICKETS_SUCCESS]: (state, { allTickets }) => ({
        ...state,
        tickets: transformTickets(allTickets),
        allTickets: allTickets,
        loadingTickets: false,
    }),
    [Types.GET_TICKETS_FAILURE]: state => ({
        ...state,
        loadingTickets: false,
    }),

    [Types.CLOSE_TICKET]: state => ({
        ...state,
        loadingCloseTicket: true,
    }),
    [Types.CLOSE_TICKET_SUCCESS]: state => ({
        ...state,
        loadingCloseTicket: false,
    }),
    [Types.CLOSE_TICKET_FAILURE]: state => ({
        ...state,
        loadingCloseTicket: false,
    }),

    [Types.GET_THREAD]: (state, { ticketId }) => ({
        ...state,
        loadingThreadId: ticketId,
    }),
    [Types.GET_THREAD_SUCCESS]: (state, { ticketId, thread }) => ({
        ...state,
        loadingThreadId: null,
        threads: {
            ...state.threads,
            [ticketId]: thread,
        },
        getThreadError: null,
    }),
    [Types.GET_THREAD_FAILURE]: (state, { getThreadError }) => ({
        ...state,
        loadingThreadId: null,
        getThreadError,
    }),
})

export default Creators
